import { render, staticRenderFns } from "./StockDestination.vue?vue&type=template&id=3e494e80&scoped=true&"
import script from "./StockDestination.vue?vue&type=script&lang=js&"
export * from "./StockDestination.vue?vue&type=script&lang=js&"
import style0 from "./StockDestination.vue?vue&type=style&index=0&id=3e494e80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e494e80",
  null
  
)

export default component.exports